import { createContext } from "react"

import { PhoneNumberDisplayFormatter } from "@shared/formatters/phoneNumberDisplayFormatter"
import { PhoneNumberPlainFormatter } from "@shared/formatters/phoneNumberPlainFormatter"
import { StringFormatter } from "@shared/formatters/stringFormatter"
import { PhoneNumber } from "@shared/types/phoneNumber"

export interface DisplayPreferencesContextValue {
  /**
   * The formatter to use for displaying a phone number to the user.
   */
  phoneDisplayFormatter: StringFormatter<PhoneNumber>

  /**
   * The formatter to use a phone number as a link. Note that it doesn't
   * add a "tel:" protocol as phones can be used with other protocols.
   */
  phoneLinkFormatter: StringFormatter<PhoneNumber>
}

export const DisplayPreferencesContext = createContext<DisplayPreferencesContextValue>({
  phoneDisplayFormatter: new PhoneNumberDisplayFormatter(),
  phoneLinkFormatter: new PhoneNumberPlainFormatter(),
})
